var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20.762,
    viewBox: "618 312.166 22 20.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(4159 936.166)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3519.138-603.238v-2.672a5.342 5.342 0 0 0-5.342-5.342h-10.685a5.342 5.342 0 0 0-5.342 5.342v2.672",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.685 9.842a5.342 5.342 0 1 1-10.685 0 5.342 5.342 0 0 1 10.685 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    transform: "matrix(.81282 0 0 .81282 -3542.919 -627.658)",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3541-603.62h22",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Line 5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    "data-name": "Rectangle 80",
    transform: "translate(-3544 -629)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.5c9b2435b6c13ecd7360a091e4cdeed4.svg";
export { ForwardRef as ReactComponent };